import { FC } from 'react';
import {
  CustomView,
  CustomViewComponent,
  CustomViewCtrls,
  CustomViewPageCategory,
  CustomViewPages,
  CustomViewTemplateIdType,
  CustomViewTypeIdType,
} from '@agilelab/plugin-wb-platform';
import preview from '../preview/marketplace_data_contract_popover_overview/marketplace_data_contract_popover_overview.png';
import thumbnail from '../preview/marketplace_data_contract_popover_overview/marketplace_data_contract_popover_overview_thumbnail.png';
import { ComponentDetailsData, componentDetailsCtrl } from '../utils';

CustomViewPages.register({
  id: 'marketplace_data_contract_popover_overview',
  meta: {
    label: 'Data Contract Popover',
    category: CustomViewPageCategory.MARKETPLACE,
    typeId: {
      type: CustomViewTypeIdType.COMPONENT_TYPE,
    },
    templateId: {
      type: CustomViewTemplateIdType.COMPONENT_TYPE,
    },
    preview: {
      thumbnail: { src: thumbnail },
      items: [{ src: preview }],
    },
  },
  data: (
    <CustomViewComponent type="container">
      <CustomViewComponent
        label="Version"
        value="{{version}}"
        type="string"
        colSpan="2"
      />
      <CustomViewComponent
        type="date"
        value="{{_system.published_at}}"
        label="Published Date"
        colSpan="2"
      />
      <CustomViewComponent type="hline" />
      <CustomViewComponent
        label="Owner"
        value="{{_system.owner_display_name}}"
        type="string"
        colSpan="2"
      />
      <CustomViewComponent
        label="Email"
        value="{{_system.descriptor.email}}"
        type="string"
        colSpan="2"
      />
      <CustomViewComponent
        type="hline"
        showWhen={{
          value: '{{ tags.length }}',
          notEquals: 0,
        }}
      />
      <CustomViewComponent
        showWhen={{
          value: '{{tags.length}}',
          notEquals: 0,
        }}
        label="Tags"
        type="tags"
        path="tags"
      />
    </CustomViewComponent>
  ),
});

export type DataContractPopoverOverviewProps = {
  data: ComponentDetailsData;
};

export const DataContractPopoverOverview: FC<
  DataContractPopoverOverviewProps
> = ({ data }) => {
  return (
    <CustomView
      id="marketplace_data_contract_popover_overview"
      typeId={data.componentInstance.descriptor.kind}
      templateId={data.componentInstance.descriptor.useCaseTemplateId}
      data={data}
    />
  );
};

CustomViewCtrls.register({
  id: 'marketplace_data_contract_popover_overview',
  function: componentDetailsCtrl,
});
